import { Component, OnInit } from '@angular/core';
import  {UserServiceService} from '../../user-service/user-service.service';
import { ToastrService } from 'ngx-toastr';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.css']
})
export class UserViewComponent implements OnInit {
    itemsPerPage = 10;
    currentPage = 1;
    numberOfUsers = [];
    blockUsr: any;
    blockUsrId: any;
    status = '';
    regExp = '';
    closeResult = '';
    userStatusList: any = [
        { id: '1', value: 'ACTIVE' },
        { id: '2', value: 'BLOCKED' }
    ];

    blockUserForm : any;

  constructor(private userService: UserServiceService,
              private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private modalService: NgbModal,
  ) {

      this.blockUserForm = this.formBuilder.group({
          comment: ['', Validators.required]
      });
  }
  public userList: any = [];
  public loading = true;

  ngOnInit() {
    this.getAllUsers(this.status, this.regExp);
  }
    pageChanged(event) {
        this.currentPage = event;
        this.getAllUsers(this.status, this.regExp);
        console.log(event);
    }
  public getAllUsers(status, regex) {
    this.loading = true;

      if (status === 'ACTIVE') {
          status = true;
      } else if (status === 'BLOCKED') {
          status = false;
      } else {
          status = '';
      }

    this.userService.getAllUsers(this.currentPage - 1, status, this.itemsPerPage, regex)
        .subscribe(data => {
          const response: any = data.json();
          this.userList = response.users;
          this.numberOfUsers = response.numberOfUsers;
          console.log(response.users);

          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

    search() {
        console.log('' + this.regExp);
        this.getAllUsers(this.status, this.regExp);
    }

    resendConfirmation(userId) {
            console.log('Resend Confirmation Email: ' + userId);
            this.userService.resendConfirmationEmail(userId).subscribe(data => {
            console.log('Resend confirmation email successful');
            this.toastr.success('', 'Successfully sent confirmation email!');



        }, (error: any) => {
            this.loading = false;
            this.toastr.error('', 'Failed to resend confirmation email, please try later!');
        });

    }

    resetPassword(userId) {
        console.log('Reset Password: ' + userId);
        this.userService.resetPassword(userId).subscribe(data => {
            console.log('Reset Password successful');
            this.toastr.success('', 'Reset password successful!');
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });

    }

    open(content, user, userId){
      this.blockUsr = user;
      this.blockUsrId = userId;

        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }

    blockUser() {

        console.log('Block Active User: ' + this.blockUsrId);
        this.blockUsr.comment = this.blockUserForm.value.comment;
        this.userService.blockUser(this.blockUsr, this.blockUsrId).subscribe(data => {
            console.log('Block User successful');
            this.toastr.success('', 'Blocked user successful!');
            this.blockUsr.active=false;
            this.blockUserForm.reset();
            this.modalService.dismissAll();
        }, error => {
            this.loading = false;
            this.toastr.error('', 'Block user failed, please try later!');
        });

    }

    onChangeStatusFilter(userStatus) {
        console.log(userStatus);
        this.status = userStatus;
        if (userStatus === 'ALL') {
            this.getAllUsers('', this.regExp);
        } else {
            this.getAllUsers(this.status, this.regExp);
        }
    }

    unBlockUser(user, userId) {
        console.log('Unblock Inactive User: ' + userId);
        user.comment = "User unblock requested";
        this.userService.unblockUser(user, userId).subscribe(data => {
            console.log('Unblock User successful');
            this.toastr.success('', 'Unblocked user successful!');
            user.active=true;
        }, (error) => {
            this.loading = false;
            this.toastr.error('', 'Unblock user failed, please try later!');
        });

    }

}
